import { render, staticRenderFns } from "./NoteActions.vue?vue&type=template&id=331ea7d2&"
import script from "./NoteActions.vue?vue&type=script&lang=ts&"
export * from "./NoteActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports